import PropTypes from 'prop-types';
import React from 'react';
import './style.scss';

const TableStatusCell = ({ status }) => {
  let label;
  switch (status) {
    case 1:
      label = 'Ok';
      break;
    case 2:
      label = 'Warning';
      break;
    case 3:
      label = 'Danger';
      break;
    default:
      break;
  }

  return (
    <div className="TableStatusCell">
      <span className='unit-status'>{label}</span>
    </div>
  );
};

TableStatusCell.propTypes = {
  status: PropTypes.number.isRequired
}

export default TableStatusCell;
